import Box from '@mui/material/Box';
import React from 'react';

type DueDateCalendarProps = {
  selectDate: any[];
  year?: number;
  month?: number;
};
function getDaysInMonth(year: number, month: number) {
  return new Date(year, month, 0).getDate();
}

function DueDateCalendar({
  selectDate,
  year = new Date().getFullYear(),
  month = new Date().getMonth() + 1,
}: DueDateCalendarProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '600px',
      }}
    >
      {[...Array(getDaysInMonth(year, month))].map((e, i) => {
        return (
          <Box
            sx={{
              width: {
                xs: '20px',
                sm: '45px',
              },
              height: {
                xs: '20px',
                sm: '45px',
              },
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '5px',
              mx: 2.5,
              my: 2,
              cursor: 'pointer',
              bgcolor: selectDate.find((val: number) => val === i + 1)
                ? '#1047DC'
                : 'transparent',
              color: selectDate.find((val: number) => val === i + 1)
                ? 'white'
                : '#1B1D22',
            }}
            key={i}
          >
            {i + 1}
          </Box>
        );
      })}
    </Box>
  );
}

export default DueDateCalendar;
